import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const QualityReviewRoute = LazyLoad(
  lazy(() => import('./quality-review').then((module) => ({ default: module.QualityReview }))),
);
